import React, { useEffect, useState } from "react";
import editActivityNoteStyle from "./editActivityNoteStyle";
import { Box, IconButton } from "@mui/material";
import { NoteAddOutlined } from "@mui/icons-material";
import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import SubmitButton from "../../Button/SubmitButton";
import { useMutation } from "@tanstack/react-query";
import { updateResource } from "../../../services/ReactQuery/reactQueryService";
import { Activity } from "../../../types/Activity";
import LegalbirdTipTapEditorProvider from "../../LbEditor/LegalbirdTipTapEditorProvider";
import { useCurrentEditor } from "@tiptap/react";
import LegalbirdTipTapEditor from "../../LbEditor/LegalbirdTipTapEditor";
import { getEditorHtml } from "../../../services/Editor/editorFunctions";

type EditActivityNoteProps = {
  activity: Activity;
  updateActivities: Function;
};

export default function EditActivityNote(props: EditActivityNoteProps) {
  return (
    <LegalbirdTipTapEditorProvider>
      <EditActivityNoteInner {...props} />
    </LegalbirdTipTapEditorProvider>
  );
}

function EditActivityNoteInner({ activity, updateActivities }: EditActivityNoteProps) {
  const updateMutation = useMutation({
    mutationFn: updateResource
  });
  const [editNoteOpen, setEditNoteOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { editor } = useCurrentEditor();

  useEffect(() => {
    editor?.commands.setContent(activity.note);
  }, [activity.note]);

  if (!editor) {
    return null;
  }

  const onSubmit = async () => {
    setIsLoading(true);
    await updateMutation.mutateAsync({
      uri: "activities",
      id: activity.id,
      data: {
        note: getEditorHtml(editor),
      },
    });
    editor.commands.clearContent();
    await updateActivities();
    setIsLoading(false);
    setEditNoteOpen(false);
  };

  return (
    <Box sx={editActivityNoteStyle.iconButtonContainer}>
      <IconButton onClick={() => setEditNoteOpen(true)}>
        <NoteAddOutlined />
      </IconButton>
      <LegalbirdIoModal
        handleClose={() => setEditNoteOpen(false)}
        open={editNoteOpen}
        submitButton={
          <SubmitButton
            onClick={onSubmit}
            variant={"contained"}
            disabled={getEditorHtml(editor) === activity.note}
            isLoading={isLoading}
          >
            Speichern
          </SubmitButton>
        }
        title={"Notiz für Beratungstermin"}
      >
        <LegalbirdTipTapEditor editorSx={{ backgroundColor: "background.note" }} />
      </LegalbirdIoModal>
    </Box>
  );
}
